// extracted by mini-css-extract-plugin
export var buttonContent = "_2t-0";
export var centered = "_2t-1";
export var centeredFlex = "_2t-2";
export var errorText = "_2t-3";
export var icon = "_2t-4";
export var iconButtonContent = "_2t-5";
export var monospace = "_2t-6";
export var padded = "_2t-7";